var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-e4d0121b-25c7-416f-9741-750cacceff4a",
    "data-name": "uuid-8a75a447-d056-4706-b7c5-e58648b49f39",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-d41add6a-15b8-442e-a12f-feda10616477",
    d: "M540,0C242.25,0,0,242.25,0,540s242.25,540,540,540,540-242.25,540-540S837.75,0,540,0ZM540,1012.5c-260.54,0-472.5-211.99-472.5-472.5S279.46,67.5,540,67.5s472.5,211.99,472.5,472.5-211.96,472.5-472.5,472.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-d41add6a-15b8-442e-a12f-feda10616477",
    d: "M573.75,523.45v-246.47c0-18.65-15.11-33.75-33.75-33.75s-33.75,15.1-33.75,33.75v279.56l279.84,216.34c6.15,4.75,13.41,7.05,20.63,7.05,10.09,0,20.07-4.48,26.71-13.12,11.4-14.77,8.68-35.93-6.05-47.33l-253.64-196.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/TimeIcon.e42dc3baa067bfcdd674a10c8cb751fa.svg";
export { ForwardRef as ReactComponent };